<template>
  <ModuleBase noPadding />
</template>
<script
  setup
  lang="ts"
>
import ModuleBase from '@/modules/ModuleBase.vue';
</script>
